import { axiosInstance as axios } from "services";

export const createCustomPlan = async (companyId, body) => {
  const { data } = await axios.post(`/admin/subscription/company/${companyId}/custom-plan`, body);
  if (!data.success) throw new Error(data.error?.message || "Failed to create custom plan");
  return data;
};

